module.exports = __webpack_public_path__ + "img/27f30ef.png";